import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./Components/ErrorHandler/ErrorBoundary";
import { Provider } from "react-redux";
import store from "./Redux/Store";
import { HelmetProvider } from "react-helmet-async";
import BugsnagErrorBoundary from "./bugnsnag";
import "./Utils/i18n";
import { ClickToComponent } from "click-to-react-component";
import { ImageKitProvider } from "@imagekit/react";
import { IK_ENDPOINT } from "./Pages/CommonPages/ImageKit";
import { SWRConfig } from "swr";

// App-wide SWR defaults, tuned mobile-first. Any useSWR call can still override
// these inline (the existing SWR pages already do, so their behavior is unchanged).
// revalidateOnFocus:false is the key one — without it, every app-switch on mobile
// triggers a refetch. Pages pass their own fetcher (get / unAuthGet / fetcher).
const swrConfig = {
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  dedupingInterval: 60000,
  errorRetryCount: 2,
  keepPreviousData: true,
};
const DevTools = () => {
  if (process.env.NODE_ENV === "production") return null;
  return <ClickToComponent />;
};

const RootComponent = () => (
  <React.StrictMode>
    <DevTools />
    <HelmetProvider>
      <BugsnagErrorBoundary>
        <BrowserRouter>
          <ErrorBoundary>
            <Provider store={store}>
              <ImageKitProvider urlEndpoint={IK_ENDPOINT}>
                <SWRConfig value={swrConfig}>
                  <App />
                </SWRConfig>
              </ImageKitProvider>
            </Provider>
          </ErrorBoundary>
        </BrowserRouter>
      </BugsnagErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootComponent />);

reportWebVitals();
